import { FlexRow } from "../box";
import { styled, theme } from "../theme";
export const Container = styled.div `
  margin-bottom: 1em;
  border: 1px solid ${({ theme }) => theme.color.gray10};

  .ReactCollapse--content {
    border-top: 1px solid ${({ theme }) => theme.color.gray10};
  }

  &:focus {
    box-shadow: 0px 0px 2px ${({ theme }) => theme.color.primary};
  }
`;
export const HeaderRow = styled(FlexRow) `
  padding: 0.6em 1.2em;
  user-select: none;
  align-items: center;

  ${({ collapsible }) => collapsible &&
    `
      background: ${theme.color.white};

      &:hover {
        cursor: pointer;
      }
  `}
`;
